import LinkButton from "./component-library3.mjs";
import GooglePlayIcon from "./component-library97.mjs";
import AmazonAppsIcon from "./component-library98.mjs";
import AppStoreIcon from "./component-library99.mjs";
import "./component-library100.mjs";
import normalizeComponent from "./component-library82.mjs";
const _sfc_main = {
  name: "GetApp",
  components: {
    LinkButton,
    GooglePlayIcon,
    AmazonAppsIcon,
    AppStoreIcon
  },
  props: {
    linkApple: {
      type: String,
      default: "https://apps.apple.com/de/app/magentazuhause/id1596295335"
    },
    linkGoogle: {
      type: String,
      default: "https://play.google.com/store/apps/details?id=de.telekom.magentazuhause"
    },
    linkAmazon: {
      type: String,
      default: () => ""
    },
    tealiumSuffix: { type: String, default: "" }
  },
  data() {
    return {
      isIOS: false,
      isDesktopOS: true
    };
  },
  mounted() {
    this.isIOS = Array.isArray(navigator.platform.match(/(iphone|ipad|ipod)/gi)) || Array.isArray(navigator.platform.match(/MacIntel/gi)) && navigator.maxTouchPoints > 0;
    this.isDesktopOS = Array.isArray(navigator.platform.match(/(Windows|Win32|WinCE|Macintosh|MacPPC|Mac68k)/gi)) || Array.isArray(navigator.platform.match(/MacIntel/gi)) && navigator.maxTouchPoints < 1;
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "get-app" }, [_vm.linkAmazon ? _c("link-button", { staticClass: "get-app__link get-app__link--ios", attrs: { "href": _vm.linkAmazon, "target": "_blank", "tealium-name": "download-app-amazon-appstore", "no-styling": "", "tealium-suffix": _vm.tealiumSuffix, "aria-label": "Zum Amazon App Store" } }, [_c("AmazonAppsIcon")], 1) : _vm._e(), _vm.isDesktopOS || _vm.isIOS ? _c("link-button", { staticClass: "get-app__link get-app__link--ios", class: { "get-app__link--solo": !_vm.isDesktopOS && _vm.isIOS }, attrs: { "href": _vm.linkApple, "target": "_blank", "tealium-name": "download-app-apple-app-store", "no-styling": "", "tealium-suffix": _vm.tealiumSuffix, "aria-label": "Zum App Store" } }, [_c("AppStoreIcon")], 1) : _vm._e(), _vm.isDesktopOS || !_vm.isIOS ? _c("link-button", { staticClass: "get-app__link get-app__link--android", class: { "get-app__link--solo": !_vm.isDesktopOS && !_vm.isIOS }, attrs: { "href": _vm.linkGoogle, "target": "_blank", "tealium-name": "download-app-google-play-store", "tealium-suffix": _vm.tealiumSuffix, "no-styling": "", "aria-label": "Zum Google Play Store" } }, [_c("GooglePlayIcon")], 1) : _vm._e()], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "550decb5",
  null,
  null
);
const getApp = __component__.exports;
export {
  getApp as default
};
